import styled from 'styled-components';

export const ContentWrapper = styled.div<{ isTwoColumn: boolean | undefined }>`
  @media (min-width: ${({ theme }) => theme.media.md}) {
    ${({ isTwoColumn }) =>
      isTwoColumn &&
      `
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        gap: 2rem;
    `}
  }
`;

export const ColumnWrapper = styled.div<{ isTwoColumn: boolean | undefined }>`
  @media (min-width: ${({ theme }) => theme.media.md}) {
    ${(props) => props.isTwoColumn && 'width: 50%;'}
  }
`;

export const AccordionContent = styled.div<{ isTwoColumn: boolean | undefined }>`
  @media (min-width: ${({ theme }) => theme.media.md}) {
    ${({ isTwoColumn }) =>
      isTwoColumn &&
      `
       padding-top: 3rem;
    `}
  }
`;

export const SummaryWrapper = styled.div`
  margin: 0 auto;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    max-width: 35rem;
  }
`;
